const replace = (currentText: string, toReplace: string, newReplace: string): string =>
   currentText.replace(toReplace, newReplace)

const capitalizeEachWord = (text: string): string =>
   text
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')

export { replace, capitalizeEachWord }
